export function hasSubanalysisInvocation(
  variables: ReadonlyArray<{ variable_role?: string | null }>,
): boolean {
  return variables.some(
    (variable) =>
      variable.variable_role != null && variable.variable_role !== "ordinary",
  );
}
